module.exports = __webpack_public_path__ + "static/media/frame_05.712fb7bc.jpg";